"use strict";

var PyDefUtils = require("PyDefUtils");
var utils = require("../utils");
const { getCssPrefix } = require("@runtime/runner/legacy-features");
const { isTrue, pyCall } = require("@Sk");
const { Component } = require("@runtime/components/Component");

module.exports = function(pyModule) {

    let updateColData = (self, colSpec, column) => {
        const existingAutoComponent = column.autoRow;
        if (existingAutoComponent) {
            existingAutoComponent.anvil$hooks.domElement.remove();
            column.autoRow = null;
        }

        const dataKey = colSpec?.data_key;
        const displayData = isTrue(self._anvil.getProp("auto_display_data"));

        if (
            !displayData ||
            !dataKey ||
            !colSpec ||
            column.colEl.children.length !== 0
        ) {
            return;
        }

        const autoRow = pyCall(Component);
        const autoRowEl = autoRow.anvil$hooks.domElement;
        autoRowEl.classList.add("anvil-designer-col-value-preview");
        autoRowEl.textContent = dataKey;
        column.autoRow = autoRow;
        column.colEl.replaceChildren(autoRowEl);
    };


    pyModule["DesignDataRowPanel"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {
        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {

            Sk.misceval.call(pyModule["DataRowPanel"].prototype["__init__"], undefined, undefined, kwargs, self);
            
            self._anvil.updateColData = updateColData.bind(null, self);

            self._anvil.whereWillItLand = function(_x, _y, _width, _height, mouseX, mouseY) {

                let hit = document.elementFromPoint(mouseX, mouseY);

                // Make sure we don't detect components inside nested containers.
                var parentContainers = $(hit).parents(".anvil-container");
                parentContainers.each(function() {
                    if (this == self._anvil.element[0]) {
                        return false; // break
                    }
                    hit = this;
                });

                let hitCol = $(hit).closest(`.${getCssPrefix()}data-row-col`);
                let myComponents = self._anvil.componentSpec.components || [];

                $(`.${getCssPrefix()}data-row-col`).removeClass("anvil-designer-hover-col");
                hitCol.addClass("anvil-designer-hover-col");

                if ((mouseY > self._anvil.element.offset().top + self._anvil.element.outerHeight() - 7 ||
                    mouseY < self._anvil.element.offset().top + 7) &&
                    !self._anvil.element.parent().hasClass("anvil-designer-component-namespace")) {
                    return {
                        redirectToElement: self._anvil.element.parent().closest(".anvil-data-grid,.anvil-data-row-panel"),
                    };
                } else if (hitCol.hasClass(`${getCssPrefix()}extra-column`)) {
                    let hitComponentSpec = hitCol.find(">.anvil-component").data("anvilPyComponent")._anvil.componentSpec;
                    let hitComponentIdx = myComponents.indexOf(hitComponentSpec);

                    let bottom = mouseY > hitCol.offset().top + hitCol.outerHeight()/2;
                    return {
                        childIdx: bottom ? hitComponentIdx + 1 : hitComponentIdx,
                        estimatedPosition: bottom ? utils.bottomOf(hitCol) : utils.topOf(hitCol),
                        estimatedPositionContainer: utils.positionOf(self._anvil.element, 2),
                        layoutProperties: { column: null },
                    };
                } else if (hitCol.length > 0 && mouseY < self._anvil.element.offset().top + self._anvil.element.outerHeight() - 14) {
                    let hitComponentEl = $(hit).closest(hitCol.find(">.anvil-component"))
                    let hitComponent = hitComponentEl.data("anvilPyComponent");
                    let idx = myComponents.length;
                    let position = utils.positionOf(hitCol);
                    if (hitComponent) {
                        let below = mouseY > hitComponentEl.offset().top + hitComponentEl.outerHeight()/2;
                        idx = myComponents.indexOf(hitComponent._anvil.componentSpec) + (below ? 1 : 0);
                        position = below ? utils.bottomOf(hitComponentEl) : utils.topOf(hitComponentEl);
                    } else if (hitCol.find(".anvil-component").length > 0) {
                        position = utils.bottomOf(hitCol.find(".anvil-component:last-child"));
                    }

                    return {
                        childIdx: idx,
                        estimatedPosition: position,
                        estimatedPositionContainer: utils.positionOf(self._anvil.element, 2),
                        layoutProperties: { column: hitCol.attr("data-grid-col-id"), },
                    };
                }

                // If all else fails, just put this component at the end.
                return {
                    childIdx: myComponents.length,
                    estimatedPosition: utils.bottomOf(self._anvil.element),
                    estimatedPositionContainer: utils.positionOf(self._anvil.element, 2),
                    layoutProperties: { column: null },
                };
            }

            self._anvil.setLayoutProperties = (pyChild, layoutProperties) => {

                if ('column' in layoutProperties) {
                    let currentCol = pyChild.anvil$hooks.domElement.closest(`.${getCssPrefix()}data-row-col`);
                    const newCol = self._anvil.getColumn(layoutProperties.column);
                    if (currentCol[0] !== newCol.colEl) {
                        const newColEl = $(newCol.colEl);
                        newColEl.find(".anvil-designer-col-value-preview").remove();
                        newColEl.append(pyChild.anvil$hooks.domElement);
                        if (currentCol.children().length == 0) {
                            currentCol.remove();
                        }
                        self._anvil.updateColumns();
                    }
                }

                return {
                    [pyChild._anvil.componentSpec.name]: layoutProperties
                };
            }

        }));

    }, 'DesignDataRowPanel', [pyModule["DataRowPanel"]]);
};
